import {ENV} from '@/constants/EnvConstants';
import {buildSandboxUrl} from '@/utils/buildSandboxUrl';
import {isProduction} from '@/utils/environment';
import {isValidUrl} from '@/utils/isValidUrl';

const BASE_URL = ENV.VITE_APIS_AI_DOMAIN_URL;
const API_BASE_KEY = 'VITE_APIS_AI_DOMAIN_URL';
const SANDBOX_KEY = `SANDBOX_${API_BASE_KEY}`;

const getQueryParam = (key: string) => {
  const params = new URLSearchParams(window.location.search);
  return params.get(key);
};

/**
 *
 * Usage priority:
 * 1. URL query parameter
 * 2. Local storage
 * 3. Default BASE_URL
 *
 * Example URL query parameters:
 * ?VITE_APIS_AI_DOMAIN_URL=https://custom.api.url/domain
 * ?SANDBOX_VITE_APIS_AI_DOMAIN_URL=mdki-xxx
 *
 * The sandbox URL will be constructed by replacing 'testing' with 'sandbox' in the BASE_URL and prefixing the path with the branch name.
 * For example, if BASE_URL is 'https://rest.testing.dev.modak.live/assistant' and the branch is 'mdki-xxx', the resulting URL will be 'https://rest.sandbox.dev.modak.live/mdki-xxx/assistant'.
 *
 * Note: The sandbox URL will only be used if the environment is not production.
 *
 */
const getApiBase = () => {
  const apiParam = getQueryParam(API_BASE_KEY);

  if (apiParam && isValidUrl(apiParam)) {
    return apiParam;
  }

  const sandboxParam = getQueryParam(SANDBOX_KEY);

  if (sandboxParam && !isProduction) {
    return buildSandboxUrl(BASE_URL, sandboxParam);
  }

  let fromStorage: string | null = null;
  try {
    fromStorage = localStorage.getItem(API_BASE_KEY);
  } catch {
    fromStorage = null;
  }

  if (fromStorage && isValidUrl(fromStorage)) {
    return fromStorage;
  }

  return BASE_URL;
};

export const apiBaseSplitBills = {
  baseUrl: getApiBase(),
  endpoints: {
    splitBills: '/chats/message',
    postUploadBillImage: '/chats/upload-split-bill',
    getUploadBillImageResult: '/chats/split-bill',
    multiPurposeChat: '/chats/multipurpose/chat',
    postFreshchatRestoreId: '/chats/contact-support',
  },
};
